import Errors from './Errors' ;

export default class Request {

    constructor(data) {
        this.originalData = data;
        this.isSubmitted = false;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }

    updateOriginalData(){
        for (let field in this.originalData) {
            this.originalData[field] = this[field];
        }
    }

    urlData() {
        let data = [];
        for (var key in this.originalData) {
            if (this.hasOwnProperty(key)) {
                if(this[key]) {
                    data.push(key + '=' + encodeURIComponent(this[key]));
                }
            }
        }
        return '?' + data.join('&');
    }

    get(url){
        return this.submit('get', url);
    }

    submit(requestType, url) {
        this.isSubmitted = true;
        return new Promise((resolve, reject) => {
            axios[requestType](url + this.urlData()).then(response => {
                this.onSuccess(response.data);
                resolve(response.data);
            }).catch(error => {
                this.onFail(error);
                reject(this.errors);
            });
        });
    }

    onSuccess(data) {
        this.updateOriginalData();
        this.isSubmitted = false;
        this.errors.clear();
    }

    onFail(errors) {
        this.isSubmitted = false;
        this.errors.record(errors.errors, errors.message);
    }
}
